// features/privateInsurance/privateInsurance.service.ts
import { post } from '../../api/api.service';

export interface PrivateInsuranceFormPayload {
  name: string;
  email: string;
  phoneNumber: string;
  message: string;
  subject: string;
  firstName?: string;
  lastName?: string;
  address?: string;
}

export const submitPrivateInsuranceFormApi = async (payload: PrivateInsuranceFormPayload) => {
  try {
    const response = await post<any>('/contactus', payload);
    return response;
  } catch (error) {
    throw error;
  }
};
